// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"58cedb6e","292":"11080840","347":"28d06199","457":"3e9d07e4","688":"fb4e1cc3","797":"84ea61b0","846":"ad8ed24f","893":"e1f75eef","921":"0b888415"}[chunkId] + ".chunk.css";
};